import { AppBaseProps, CommonApp, Context, Entity, Metadata } from "../core/components/commonApp.js";
import { AppHelper } from "../appHelper.js";
import { EntityTicketForward, Forward, TicketForwardAppProps } from "./forward.js";
import { CreateAssignment, CreateAssignmentAppProps } from "./createAssignment.js";
import { Helper } from "../core/util/helper.js";
import { MetaDataHelper } from "../core/util/metaDataHelper.js";
import { General } from "../../siteManagement/general.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { Config } from "../core/config/config.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { Dialog, DialogProps } from "../core/components/dialog.js";
import { FieldInstance } from "../core/components/field.js";
import { DropDownList } from "../core/components/dropDownList.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import Skills from "../core/components/skills.js";
import { OpenTicketChangeStateDialog } from "./ticketChangeStateDialog.js";
import { TreeNodeVm } from "../generalSettings/skills/skillsInterfaces.js";
import { IsSearchFieldField } from "../core/components/isSearchField.js";
import { EventEntry, TicketConversation } from "./conversationHistory.js";
import { PageTitleProps } from "../core/components/pageTitle.js";
import { openChat } from "../chatAssistant/assistantDialog.js";
import React from "react";
import ReactDOM from "react-dom";

export class TicketApp extends React.Component<TicketAppProps, any> {
    private _firstEdit = {};
    private _lockId: number;
    private _conversationHistoryChangedExistingTextOrType: boolean = false;
    private _conversationHistoryNewText: boolean = false;
    private _conversationTextRequired: string | boolean = false;
    private _errorCodesInitialReadOnlyState = {
        OrtText: false,
        StoerungText: false,
        UrsacheText: false,
        BehebungText: false
    };
    readOnly: boolean = false;
    common = new AppHelper();
    pCloseEnabled: boolean = false;
    pForwardEnabled: boolean = false;
    pOpenEnabled: boolean = false;
    showForward: boolean = false;
    currentUrl: string = null;
    translations = {
        Problem: "Beschreibung",
        Anmerkung: "Anmerkung",
        Behebung: "Behebung"
    };
    articleGridOptions: {};
    historyGridOptions: {};
    ticketLevelGridOptions: {};
    editMachineTicketsGridOptions: {};
    ticketStructureTemplate: string;
    ticketStructureTemplateMobileApp: string;
    //schaltet den Browsertab-Titel an; wird von common aufgerufen
    setTabTitle = true;
    slaData: SlaData;
    enableEditButton: boolean = false;
    isTIDActive: boolean = false;
    abhaengigkeitCodes: boolean = false;
    constructor(props: TicketAppProps) {
        super(props);
        this.slaData = { slaExists: props.entity.SlaExists };
        this.common.enableHooks = true;
        this.common.init(this);
        this.readOnly = this.props.readOnly;
        this._initApp();
    }

    private _setCodesText(textField: any, langTextField: any, dataItem: any, value = null) {
        // Wenn dataItem leer ist und dies ist der Fall wenn der Code aus der Statistik ausgewählt wird!
        if (!Helper.hasValue(dataItem) && value !== null && value != "") {
            let url = "";
            let param = "";

            if (textField == "entity.OrtText") {
                url = "ProcedureLookup/FindCodeForProort?text=" + encodeURIComponent(value)
                param = "";
            }
            else if (textField == "entity.StoerungText") {
                url = "ProcedureLookup/FindCodeForProstoer?text=" + encodeURIComponent(value) + "&proOrt=";
                param = this.props.entity.OrtCode;
            }
            else if (textField == "entity.UrsacheText") {
                url = "ProcedureLookup/FindCodeForPrours?text=" + encodeURIComponent(value) + "&proStoer="
                param = this.props.entity.StoerungCode;
            }
            else if (textField == "entity.BehebungText") {
                url = "ProcedureLookup/FindCodeForProbeh?text=" + encodeURIComponent(value) + "&proUrs="
                param = this.props.entity.UrsacheCode;
            }

            HTTPService.get<Array<any>>(url + encodeURIComponent(param))
                .then(result => {
                    if (result.length > 0) {
                        MetaDataHelper.setFieldValue(this.props.entity, textField, result[0].Text);
                        MetaDataHelper.setFieldValue(this.props.entity, langTextField, result[0].LangText);
                        this.setState({});
                    }
                });
        }
        else {
            let text = Helper.hasValue(dataItem) ? (Helper.hasValue(dataItem.text) ? dataItem.text : dataItem.Text) : "";
            let langtext = Helper.hasValue(dataItem) ? (Helper.hasValue(dataItem.langtext) ? dataItem.langtext : dataItem.LangText) : "";
            const code = Helper.hasValue(dataItem) ? (Helper.hasValue(dataItem.code) ? dataItem.code : dataItem.Code) : "";
            if (code !== value) {
                text = "";
            }
            MetaDataHelper.setFieldValue(this.props.entity, textField, text);
            MetaDataHelper.setFieldValue(this.props.entity, langTextField, langtext);
        }
    }

    private _addFromCode(modelProperty: any, textToAdd: any) {
        let newValue: string;
        if (this._firstEdit[modelProperty] !== false) {
            this._firstEdit[modelProperty] = false;
            const dateString = kendo.toString(new Date(), "G");
            const computedValue = dateString + " - " + this.props.entity.Settings.UsernameForTimestamp + "\n";
            if (this.props.entity.Settings.ProblemTextVorgangAmAnfangHinzufuegen)
                newValue = computedValue + textToAdd + "\n" + (this.props.entity[modelProperty] ? this.props.entity[modelProperty] : "");
            else
                newValue = (this.props.entity[modelProperty] ? this.props.entity[modelProperty] + "\n" : "") + computedValue + textToAdd;
        }
        else {
            if (this.props.entity.Settings.ProblemTextVorgangAmAnfangHinzufuegen)
                newValue = textToAdd + "\n" + (this.props.entity[modelProperty] ? this.props.entity[modelProperty] : "");
            else
                newValue = (this.props.entity[modelProperty] ? this.props.entity[modelProperty] + "\n" : "") + textToAdd;
        }

        this.common.handleFieldChange({ model: "entity." + modelProperty }, newValue);
    };

    private _createNewComment = (type: number): TicketConversation => {
        return {
            AddDate: Helper.dates.getISODateString(new Date()),
            Id: kendo.guid(),
            IsSaved: false,
            IsChanged: false,
            Level: this.props.entity.Stufe,
            Name: Config.user.userName,
            FullName: Config.user.fullName,
            Text: "",
            Type: type,
            UTCAddDate: null
        };
    }

    private _updateCurrentUrl() {
        if (this.props.entity.IsNew === true) {
            this.currentUrl = Config.baseUrl + "Procedure/New";
        } else {
            this.currentUrl = Config.baseUrl + "Procedure/Edit/" + this.props.entity.ProblemNr;
        }
    }

    private _updateButtonFlags() {
        this.pCloseEnabled = !this.props.entity.IsNew && this.props.entity.RecordRight.CanClose;
        this.pForwardEnabled = this.props.entity.RecordRight.CanForward;
        this.pOpenEnabled = !this.props.entity.IsNew && this.props.entity.RecordRight.CanReopen;
    }

    private _reloadEntity = (readOnly: boolean = false) => {
        return new Promise<void>(resolve => {
            HTTPService.get<JsonResultClass<EntityTicket>>('Procedure/Get/?id=' + this.props.entity.ProblemNr + "&readOnly=" + readOnly)
                .then((newData) => {
                    if (newData.Code === 0) {
                        this.readOnly = readOnly;
                        this.enableEditButton = readOnly;
                        if (newData.Data.RecordRight.CanWrite && Helper.hasValue(newData.Data.IsId) && this.props.entity.IsId !== newData.Data.IsId) {
                            this.releaseLock();
                            this._lockId = Helper.keepLockAlive("Lock.ashx", newData.Data.IsId, "PROBLEME", 10000);
                        }
                        if (this.readOnly) {
                            this.releaseLock();
                            NotificationHelper.showInfoMessage(this.translations["Vorgang.OpenInReadOnly"].replace("{ticketNr}", this.props.context.keyVal1));
                        }
                        Helper.updateEntity(this.props.entity, newData.Data);
                        $.extend(this.props.entity.RecordRight, newData.Data.RecordRight);
                        this._updateButtonFlags();

                        if (!Helper.hasValue(this.common.unloadHelper)) {
                            this.common.createUnloadHelper();
                        }

                        this.setState({}, () => {
                            this.common.sheetWrapper.trigger(SheetEventType.Custom, { event: "Reloading" });
                            resolve();
                        });
                    } else {
                        NotificationHelper.showErrorMessage(newData.Message);
                        resolve();
                    }
                });
        });
    }

    private async _handleCloseReopen(isClose: boolean) {
        const question = isClose ? this.translations["Vorgang.VorgangSchliessenFrage"] : this.translations["Vorgang.VorgangWiedereroeffnenFrage"]
        const url = 'Procedure/' + (isClose ? "Close" : "Reopen") + "/" + this.props.entity.ProblemNr;

        let isOk = await DialogHelper.confirm(question);

        if (isOk) {
            if (isClose) {
                let saveResult = await this.save(false);
                if (!saveResult)
                    return;
            }

            let result = await HTTPService.post<JsonResultClass>(url);

            if (result.Code === 0) {
                if (isClose)
                    // KT - leider kann man SendBeacon nicht abwarten - also wissen wir nicht, wann die Sperre freigegeben wird. 
                    this.releaseLock();
                NotificationHelper.showSuccessMessage(result.Message);
                await this._reloadEntity();
                //trigger documents event
                $(window).trigger("toggleDocumentUpload", { allow: !isClose });

                if (!isClose) {
                    this._firstEdit = {};
                }
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    private _checkSLARelation = (problemType: any, maschnr: any) => {
        const problemNr = this.props.entity.ProblemNr;
        if (maschnr !== null && problemType !== null && problemNr !== null) {
            const url = "ProcedureLookup/SlaExists?problemNr=" + encodeURIComponent(problemNr.toString()) + "&problemType=" + encodeURIComponent(problemType) + "&maschNr=" + encodeURIComponent(maschnr);
            if ((this.props.entity.Adresse_Key === null || this.props.entity.Adresse_Key === "")) {
                HTTPService.chainBatch
                    .add<{ AdrNr: string }>("MachineLookup/MachineHeader?id=" + encodeURIComponent(maschnr))
                    .add<JsonResultClass<boolean>>(url)
                    .promise()
                    .then(result => {
                        MetaDataHelper.setFieldValue(this.props.entity, "entity.Adresse_Key", result[0].AdrNr);
                        this.slaData.slaExists = result[1].Data;
                        this.setState({});
                    });
            }
            else {
                HTTPService.get(url)
                    .then(result => {
                        this.slaData.slaExists = result.Data;
                        this.setState({});
                    });
            }
        }
        else {
            this.slaData.slaExists = false;
            this.setState({});
        }
    }

    private _addUrlParam = (url: string, param: string, value: any): string => {
        let u = url;
        const paramName = param + "=";
        const paramIdx = u.indexOf(paramName);
        if (u.indexOf("?") === -1) {
            u += "?";
        }
        if (u.indexOf("=") > 0 && paramIdx === -1) {
            u += "&";
        }
        if (paramIdx > 0) {
            const parts = u.split(paramName);
            u = parts[0] + paramName + value;
            const idx = parts[1].indexOf("&");
            if (idx > -1) {
                u += parts[1].slice(idx);
            }
        } else {
            u += paramName + value;
        }
        return u;
    }

    private _handleCodesHierarchy = (codeType: CodesType, value: string, init: boolean) => {
        if (this.props.cascadingCodes === true) {
            const hasValue = Helper.hasValue(value) && value.trim && value.trim() !== "";
            switch (codeType) {
                case CodesType.Location:
                    this._disableAndResetCodes(2, init);
                    if (hasValue) {
                        MetaDataHelper.setReadOnly(this.props.metadata, "entity.StoerungCode", false);
                        if (this._errorCodesInitialReadOnlyState.StoerungText !== true) {
                            MetaDataHelper.setReadOnly(this.props.metadata, "entity.StoerungText", false);
                        }
                    }
                    break;
                case CodesType.Fault:
                    this._disableAndResetCodes(3, init);
                    if (hasValue) {
                        MetaDataHelper.setReadOnly(this.props.metadata, "entity.UrsacheCode", false);
                        if (this._errorCodesInitialReadOnlyState.UrsacheText !== true) {
                            MetaDataHelper.setReadOnly(this.props.metadata, "entity.UrsacheText", false);
                        }
                    }
                    break;
                case CodesType.Cause:
                    this._disableAndResetCodes(4, init);
                    if (hasValue) {
                        MetaDataHelper.setReadOnly(this.props.metadata, "entity.BehebungCode", false);
                        if (this._errorCodesInitialReadOnlyState.BehebungText !== true) {
                            MetaDataHelper.setReadOnly(this.props.metadata, "entity.BehebungText", false);
                        }
                    }
                    break;
                default: return;
            }
            this._setCodeSearchWindowUrl(codeType, value);
        }
    }

    private _setCodeSearchWindowUrl = (codeType: CodesType, value: string) => {
        let field: IsSearchFieldField = null;
        switch (codeType) {
            case CodesType.Location:
                field = MetaDataHelper.getFieldByProperty(this.props.metadata, "model", "entity.StoerungCode");
                break;
            case CodesType.Fault:
                field = MetaDataHelper.getFieldByProperty(this.props.metadata, "model", "entity.UrsacheCode");
                break;
            case CodesType.Cause:
                field = MetaDataHelper.getFieldByProperty(this.props.metadata, "model", "entity.BehebungCode");
                break;
            default: return;
        }
        if (Helper.hasValue(field))
            field.searchWindowUrl = this._addUrlParam(field.searchWindowUrl, "cus_code", value);
    }

    //maxLevel => 1 = OrtCode, 2 = StoerungCode, 3 = UrsacheCode, 4 = BehebungCode
    private _disableAndResetCodes = (minLevel: number, justDisable: boolean) => {
        if (minLevel <= 4) {
            MetaDataHelper.setReadOnly(this.props.metadata, "entity.BehebungCode", true);
            if (this._errorCodesInitialReadOnlyState.BehebungText !== true) {
                MetaDataHelper.setReadOnly(this.props.metadata, "entity.BehebungText", true);
            }
            if (!justDisable) {
                MetaDataHelper.setFieldValue(this.props.entity, "entity.BehebungCode", null);
                MetaDataHelper.setFieldValue(this.props.entity, "entity.BehebungText", null);
                MetaDataHelper.setFieldValue(this.props.entity, "entity.BehebungLangText", null);
            }
            if (minLevel <= 3) {
                MetaDataHelper.setReadOnly(this.props.metadata, "entity.UrsacheCode", true);
                if (this._errorCodesInitialReadOnlyState.UrsacheText !== true) {
                    MetaDataHelper.setReadOnly(this.props.metadata, "entity.UrsacheText", true);
                }
                if (!justDisable) {
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.UrsacheCode", null);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.UrsacheText", null);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.UrsacheLangText", null);
                }
                if (minLevel <= 2) {
                    MetaDataHelper.setReadOnly(this.props.metadata, "entity.StoerungCode", true);
                    if (this._errorCodesInitialReadOnlyState.StoerungText !== true) {
                        MetaDataHelper.setReadOnly(this.props.metadata, "entity.StoerungText", true);
                    }
                    if (!justDisable) {
                        MetaDataHelper.setFieldValue(this.props.entity, "entity.StoerungCode", null);
                        MetaDataHelper.setFieldValue(this.props.entity, "entity.StoerungText", null);
                        MetaDataHelper.setFieldValue(this.props.entity, "entity.StoerungLangText", null);
                    }
                    if (minLevel <= 1) {
                        MetaDataHelper.setReadOnly(this.props.metadata, "entity.OrtText", true);
                        if (this._errorCodesInitialReadOnlyState.OrtText !== true) {
                            MetaDataHelper.setReadOnly(this.props.metadata, "entity.OrtText", true);
                        }
                        if (!justDisable) {
                            MetaDataHelper.setFieldValue(this.props.entity, "entity.OrtText", null);
                            MetaDataHelper.setFieldValue(this.props.entity, "entity.OrtText", null);
                            MetaDataHelper.setFieldValue(this.props.entity, "entity.OrtLangText", null);
                        }
                    }
                }
            }
        }
    }

    private _addConversationsToContext = () => {
        if (this.props.context.conversationMode) {

            //problem
            if (!Helper.hasValue(this.props.context.problemConversation)) {
                this.props.context.problemConversation = [];
            }
            if (Array.isArray(this.props.entity.ProblemHistory)) {
                this.props.context.problemConversation = this.props.entity.ProblemHistory;
            }
            //anmerkung
            if (!Helper.hasValue(this.props.context.annotationConversation)) {
                this.props.context.annotationConversation = [];
            }
            if (Array.isArray(this.props.entity.AnnotationHistory)) {
                this.props.context.annotationConversation = this.props.entity.AnnotationHistory;
            }
            //loesung
            if (!Helper.hasValue(this.props.context.solutionConversation)) {
                this.props.context.solutionConversation = [];
            }
            if (Array.isArray(this.props.entity.SolutionHistory)) {
                this.props.context.solutionConversation = this.props.entity.SolutionHistory;
            }
            //events
            if (!Helper.hasValue(this.props.context.events)) {
                this.props.context.events = [];
            }
            if (Array.isArray(this.props.entity.Events)) {
                this.props.context.events = this.props.entity.Events;
            }
            this.props.context.textToHighlight = General.Sheet.Manager.getTopMostSheet().getExternalData()?.textToHighlight;
        }
    }

    private _validateCommentHistory = () => {
        if (this.props.context.conversationMode === true) {
            let required = this._conversationTextRequired;

            if (typeof required === "string") {
                required = this.common.evalAction(required);
            }

            if (!required) {
                return [];
            }

            if (!Array.isArray(this.props.entity.ProblemHistory)
                || this.props.entity.ProblemHistory.length === 0
                || (this.props.entity.ProblemHistory.length === 1&&
                    (!Helper.hasValue(this.props.entity.ProblemHistory[0].Text) || this.props.entity.ProblemHistory[0].Text.trim() === ""))) {
                let field = null;
                let tabName = null

                for (let i = 0; i < this.props.metadata.tabs.length; i++) {
                    const tab = this.props.metadata.tabs[i];
                    if (Array.isArray(tab.regions)) {
                        for (let j = 0; j < tab.regions.length; j++) {
                            const region = tab.regions[j];
                            for (let k = 0; k < region.fields.length; k++) {
                                if (region.fields[k].model === "entity.Problem" || region.fields[k].model === "entity.Conversation") {
                                    field = region.fields[k];
                                    tabName = tab.title;
                                    break;
                                }
                            }
                        }
                    }
                }

                return [{ name: field.name, tabName: tabName }];
            }

            return [];
        }
        return [];
    }
    private _handleForward = async () => {
        if (Config.user.isExternal) {
            await this._forwardExternalUser()
        }
        else {
            await this._showForwardWindow()
        }
    }

    private _forwardExternalUser = async () => {
        const hotliner = await this.get_hotliner();
        if (Helper.isNullOrEmpty(hotliner)) {
            return
        }
        const entity: EntityTicketForward = {
            IsNew: false,
            IsWatchable: false,
            IsWatched: false,
            RecordRight: this.props.entity.RecordRight,
            Hotliner_Key: hotliner,
            ProblemNr: this.props.entity.ProblemNr,
            Stufe: this.props.entity.Stufe,
            Kommentar: this.props.entity.Kommentar,
            Vorgangsstatus_Key: this.props.entity.Vorgangsstatus_Key,
            Termin1: this.props.entity.Termin1,
            TicketValid: true,
            ValidationMessage: "",
            IndividualFields: this.props.entity.IndividualFields
        }
        let result = await HTTPService.post<JsonResultClass>("Procedure/Forward", entity);
        if (result.Code === 0) {
            //this.props.entity.IsNew = false;
            await this._reloadEntity(true);
            NotificationHelper.showSuccessMessage(Helper.getTranslation("Vorgang.ForwardSuccessful"));
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
        //this.common.handlePostSave(result.Code === 0, true);
    }

    private get_hotliner = () => {
        return new Promise<string>(async (resolve, reject) => {
            const result = await HTTPService.get<JsonResultClass>('Procedure/ForwardInit/' + this.props.entity.ProblemNr);
            if (result.Code != 0) {
                reject(result.Message);
            }

            const dataSource: { Value: string }[] = result.AdditionalData["Hotliners"];
            if (!Helper.hasValue(dataSource) || dataSource.length == 0) {
                reject("Error at determining hotliners");
            }

            const targetElement = $("<div>");
            $("body").append(targetElement);

            const remove_dialog = () => {
                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
            }

            let value = dataSource[0].Value;
            const props = ComponentHelper.createFactory().getDefaultDropDownProps();
            props.onChange = (_, new_value) => {
                value = new_value;
            }
            props.value = value;
            props.field.optionLabel = "";
            props.dataSource = dataSource;
            props.field.dataTextField = "Name";
            props.field.dataValueField = "Value";

            const dialogProps: DialogProps = {
                title: "",
                width: "500px",
                actions: [
                    {
                        label: Config.translations.cancel,
                        action: () => {
                            resolve(null)
                        }
                    },
                    {
                        label: Config.translations.ok,
                        action: () => {
                            resolve(value)
                        },
                        primary: true
                    }
                ],
                afterClose: () => {
                    remove_dialog();
                }
            };
            ReactDOM.render(
                <Dialog {...dialogProps} open={true} >
                    <FieldInstance label={Helper.getTranslation("Field.Vorgang.hotliner")} noHover={true}>
                        <DropDownList {...props} />
                    </FieldInstance>
                </Dialog >, targetElement[0]);

        });
    }

    private _showForwardWindow = async () => {
        let result = await HTTPService.chainBatch
            .add<JsonResultClass<EntityTicketForward>>('Procedure/ForwardInit/' + this.props.entity.ProblemNr)
            .add<Metadata>(Helper.getMetaData("procedureForward"))
            .promise();
        if (!result[0].Data.TicketValid) {
            NotificationHelper.showErrorMessage(result[0].Data.ValidationMessage);
            return;
        }

        const sheet = General.Sheet.Manager.createSheet();
        sheet.setTitle(this.translations["Vorgang.VorgangWeiterleiten"]);

        sheet.show(() => {
            const props: TicketForwardAppProps = {
                context: this.props.context,
                dataSources: {
                    hotkeyDataSource: null,
                    prostatuskeyDataSource: null
                },
                title: null,
                metadata: result[1],
                entity: result[0].Data,
                isWindow: true,
                //onBeforeForward: this.save,
                onAfterForward: null,
                ticketStatus: Helper.hasValue(this.props.entity.Vorgangsstatus_Key) ? this.props.entity.Vorgangsstatus_Key.toString() : null,
                ticketTyp: Helper.hasValue(this.props.entity.Vorgangstyp_Key) ? this.props.entity.Vorgangstyp_Key.toString() : null,
                useStatusRights: this.props.externalStatusChangesHotliner,
                externalStatusDependsOnTicketType: this.props.externalStatusDependsOnTicketType,
                handleMenuSelect: null,
                enableMenuItem: null,
                handleCreateValidator: null,
                handleFieldChange: null,
                handleDataLoaded: null,
                onChange: null
            };
            sheet.bind(SheetEventType.SavedSuccessfully, async () => {
                General.Functions.HistoryState.replaceState(`Procedure/Read?id=${this.props.entity.ProblemNr}`);
                await this._reloadEntity(true);
            })
            sheet.mountContent(Forward, props);
        });
    }

    canOpenAdd = () => {
        if (!this.props.entity.IsNew && this.common.unloadHelper.isEntitySaved()) {
            return true;
        } else {
            debugger;
            NotificationHelper.showWarningMessage(Config.translations.saveDataFirst);
            return false;
        }
    }

    releaseLock = () => {
        if (this._lockId != undefined) {
            clearInterval(this._lockId);
            Helper.releaseLock(this.props.entity.IsId, "PROBLEME");
            this._lockId = undefined;
        }
    }

    openInEditMode = () => {
        HTTPService.get<JsonResultClass<boolean>>("ProcedureLookup/CheckLock?ticketNr=" + this.props.entity.ProblemNr + "&level=" + this.props.entity.Stufe).then(result => {
            if (result.Code === 0) {
                if (result.Data) {
                    let url = Config.baseUrl + "Procedure/Edit?id={ticketNr}";
                    window.location.href = url.replace("{ticketNr}", this.props.entity.ProblemNr.toString());
                } else {
                    NotificationHelper.showErrorMessage(this.translations["Vorgang.AlreadyOpen"].replace("{userName}", result.AdditionalData.LockedBy).replace("{ticketNr}", this.props.entity.ProblemNr.toString()));
                }
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        });
    }


    handleFieldChange = (field: any, value: any, dataItem: any = null, isInit = false) => {
        let tmpField = field;
        switch (field.model) {
            case "entity.OrtCode":
                this._setCodesText("entity.OrtText", "entity.OrtLangText", dataItem, value);
                if (MetaDataHelper.getFieldValue(this.props.entity, "entity.OrtCode") !== value) {
                    this._handleCodesHierarchy(CodesType.Location, value, false);
                }
                break;
            case "entity.StoerungCode":
                this._setCodesText("entity.StoerungText", "entity.StoerungLangText", dataItem, value);
                if (MetaDataHelper.getFieldValue(this.props.entity, "entity.StoerungCode") !== value) {
                    this._handleCodesHierarchy(CodesType.Fault, value, false);
                }
                break;
            case "entity.UrsacheCode":
                this._setCodesText("entity.UrsacheText", "entity.UrsacheLangText", dataItem, value);
                if (MetaDataHelper.getFieldValue(this.props.entity, "entity.UrsacheCode") !== value) {
                    this._handleCodesHierarchy(CodesType.Cause, value, false);
                }
                break;
            case "entity.BehebungCode":
                this._setCodesText("entity.BehebungText", "entity.BehebungLangText", dataItem, value);
                if (MetaDataHelper.getFieldValue(this.props.entity, "entity.BehebungCode") !== value) {
                    this._handleCodesHierarchy(CodesType.Repair, value, false);
                }
                break;
            case "entity.Vorgangstyp_Key":
                this._checkSLARelation(value, this.props.entity.Maschine_Key);
                break;
            case "entity.Vorgangsstatus_Key":
                break;
            case "entity.Ansprechpartner_Key":
                if (dataItem !== null && (!Helper.hasValue(this.props.entity.Adresse_Key) || this.props.entity.Adresse_Key === "")) {
                    if (Helper.hasValue(dataItem.adrnr)) {
                        MetaDataHelper.setFieldValue(this.props.entity, "entity.Adresse_Key", dataItem.adrnr);
                    }
                    if (Helper.hasValue(dataItem.AdrNr)) {
                        MetaDataHelper.setFieldValue(this.props.entity, "entity.Adresse_Key", dataItem.AdrNr);
                    }
                }
                break;
            case "entity.Maschine_Key":
                if (dataItem !== null && this.props.entity.IsNew && !Helper.hasValue(this.props.entity.Adresse_Key)) {
                    if (Helper.hasValue(dataItem.adrnr))
                        MetaDataHelper.setFieldValue(this.props.entity, "entity.Adresse_Key", dataItem.adrnr);
                    if (Helper.hasValue(dataItem.AdrNr))
                        MetaDataHelper.setFieldValue(this.props.entity, "entity.Adresse_Key", dataItem.AdrNr);
                }
                this._checkSLARelation(this.props.entity.Vorgangstyp_Key, value);
                break;
            case "entity.Projekt_Key":
                if (dataItem !== null && Helper.isNullOrEmpty(this.props.entity.Adresse_Key)) {
                    if (Helper.hasValue(dataItem.adrnr))
                        MetaDataHelper.setFieldValue(this.props.entity, "entity.Adresse_Key", dataItem.adrnr);
                    if (Helper.hasValue(dataItem.AdrNr))
                        MetaDataHelper.setFieldValue(this.props.entity, "entity.Adresse_Key", dataItem.AdrNr);
                }
                break;
            case "entity.StartZeit":
                this.props.entity.StartZeitUtc = value;
                break;
            default:
                break;
        }

        if (!isInit) {
            this.common.handleFieldChange(tmpField, value, dataItem);
        }
    }

    handleIsSearchFieldFullObjectModel = (field: any, dataItem: any) => {
        let changed = true;
        switch (field.model) {
            case "entity.OrtCode":
                this._setCodesText("entity.OrtText", "entity.OrtLangText", dataItem, dataItem.code);
                break;
            case "entity.StoerungCode":
                this._setCodesText("entity.StoerungText", "entity.StoerungLangText", dataItem, dataItem.code);
                break;
            case "entity.UrsacheCode":
                this._setCodesText("entity.UrsacheText", "entity.UrsacheLangText", dataItem, dataItem.code);
                break;
            case "entity.BehebungCode":
                this._setCodesText("entity.BehebungText", "entity.BehebungLangText", dataItem, dataItem.code);
                break;
            default:
                changed = false;
                break;
        }

        if (changed) {
            this.common.handleFieldChange({ model: "" }, null, null);
        }
    }
    private _setEvents = () => {
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(
            SheetEventType.Custom, (cus) => {
                if (cus.command === "ConversationHistoryText") {
                    this._conversationHistoryChangedExistingTextOrType = cus.changedExistingTextOrType;
                    this._conversationHistoryNewText = cus.newText;
                }
            });

        sheet.bind(
            SheetEventType.Custom, (cus) => {
                if (cus.command === "saveTicketIntern") {

                    this.save(false).then()
                }
            });
    }

    save = async (closeAfterSave: boolean): Promise<boolean> => {
        for (const loadedModule of this.common.getLoadedModules()) {
            loadedModule.Save();
        }
        if (this._conversationHistoryChangedExistingTextOrType || this._conversationHistoryNewText) {
            let sheet = General.Sheet.Manager.getTopMostSheet();
            let isOK = await DialogHelper.confirm(this.translations["Standard.Ticketsystem.TexteSpeichern"], 700, this.translations["Server.No"], this.translations["Server.Yes"])
            if (isOK) {
                sheet.trigger(SheetEventType.Custom, { command: "addTicketText", value: true });
            }
            else {
                sheet.trigger(SheetEventType.Custom, { command: "deleteTicketText", value: true })
            }
            return await this.saveTicket(closeAfterSave);
        } else {
            return await this.saveTicket(closeAfterSave);
        }
    }

    openCockpit = () => {
        if (Helper.hasValue(this.props.entity.Maschine_Key))
            General.Sheet.Manager.createSheetWithUrl(`Cockpit/IndexMachine?id=${encodeURIComponent(this.props.entity.Maschine_Key)}`, null, null, false);
        else
            General.Sheet.Manager.createSheetWithUrl(`Cockpit/IndexAddress?id=${encodeURIComponent(this.props.entity.Adresse_Key)}`, null, null, false);
    }

    private saveTicket = async (closeAfterSave: boolean): Promise<boolean> => {
        if (!this.common.validate(this._validateCommentHistory()))
            return false;

        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.trigger(SheetEventType.Custom, { command: "entityStatusChanged", value: true });

        let result = await HTTPService.post<JsonResultClass>("Procedure/Save", this.props.entity)
        let returnNull = true;
        if (result.Code !== 0) {
            NotificationHelper.showErrorMessage(result.Message);
            return false;
        }

        if (this.props.entity.IsNew) {
            General.Functions.HistoryState.replaceState("Procedure/Edit?id=" + this.props.entity.ProblemNr);
        }

        if (Helper.hasValue(this.props.entity.IsId) && this._lockId == undefined) {
            this._lockId = Helper.keepLockAlive("Lock.ashx", this.props.entity.IsId, "PROBLEME", 10000);
        }

        this.props.entity.IsNew = false;
        $(window).trigger("saveSkills", this.props.entity);
        NotificationHelper.showSuccessMessage(result.Message);

        if (!closeAfterSave) {
            returnNull = false;
        }

        let copiedEntity = JSON.parse(JSON.stringify(this.props.entity));
        copiedEntity.IsSaved = true;
        Helper.updateEntity(this.props.entity, copiedEntity);
        this.common.handlePostSave(result.Code === 0, closeAfterSave);

        if (!returnNull) {
            await this._reloadEntity();
        }

        return true;
    }

    remove = async () => {
        let isOK = await DialogHelper.confirm(Config.translations.deleteMessage)
        if (!isOK) return;
        let result = await HTTPService.post<JsonResultClass>('Procedure/Delete?problemNr=' + this.props.entity.ProblemNr)
        if (result.Code === 0) {
            NotificationHelper.showSuccessMessage(result.Message);
            if (this.common.isWindow) {
                this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
                this.common.sheetWrapper.hide();
            } else {
                this.props.entity.RecordRight.CanWrite = false;
                this.props.entity.RecordRight.CanDelete = false;
                this.setState({});
                this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
                setTimeout(() => {
                    window.location.href = Config.baseUrl + "DynamicSearch/Procedure";
                }, 1000);
            }
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    copyFaultCode = () => {
        let textToAdd = "";

        if (this.props.entity.StoerungCode || this.props.entity.StoerungText) {
            textToAdd = (this.props.entity.StoerungCode || "") + " - " + (this.props.entity.StoerungText || "");

        }
        if (this.props.context.conversationMode) {
            let comment = this._createNewComment(1);
            comment.Text = textToAdd;
            this.props.entity.ProblemHistory.push(comment);
        }
        else {
            this._addFromCode("Problem", textToAdd);
        }
    }

    copyRectificationCode = () => {
        let textToAdd = "";
        if (this.props.entity.BehebungCode || this.props.entity.BehebungText) {
            textToAdd = (this.props.entity.BehebungCode || "") + " - " + (this.props.entity.BehebungText || "");

        }
        if (this.props.context.conversationMode) {
            let comment = this._createNewComment(3);
            comment.Text = textToAdd;
            this.props.entity.SolutionHistory.push(comment);
        }
        else {
            this._addFromCode("Loesung", textToAdd);
        }
    }

    openCreateAssignment = () => {
        this._internalActionExecute(() => this._openCreateAssignmentInternal()).then();
    }

    private _commentTypeText = (ct: Number) => {

        switch (ct) {
            case 2:
                return Helper.getTranslation("Field.Vorgang.anmerkung");
            case 3:
                return Helper.getTranslation("WebSMS.Procedure.RectificationText");
            default:
                return Helper.getTranslation("Regionen.Vorgang.Beschreibung");
        }
    }

    private _openCreateAssignmentInternal = () => {
        function getHourAndMinute(timeString: string) {
            let h = null, m = null;
            if (timeString.length === 5) {
                h = parseInt(timeString.slice(0, 2), 10);
                m = parseInt(timeString.slice(3, 5), 10);
            }
            return { h: h, m: m };
        }

        function updateTime(date: Date, timeString: string) {
            const time = getHourAndMinute(timeString);
            date.setHours(time.h);
            date.setMinutes(time.m);
        }

        if (this.canOpenAdd()) {
            HTTPService.chainBatch
                .add<JsonResultClass>("Procedure/AssignmentInit")
                .add<Metadata>(Helper.getMetaData("createAssignment"))
                .add("Procedure/AssignmentSettings")
                .add<JsonResultClass>("ResourcePlanning/DefaultResourceForProject?projNr=" + encodeURI(this.props.entity.Projekt_Key))
                .promise()
                .then(results => {
                    const entity = results[0].Data;
                    const metaData = results[1];
                    if (metaData && metaData.rightDrawerContainer) {
                        let comp = metaData.rightDrawerContainer.multipleComponents.find(comp => comp.iskey === "RIGHTDRAWER_COMPONENT_IFRAME");
                        if (comp) {
                            comp.props.url = "{{helpBaseUrl}}/{{helpVersion}}/{{helpLanguage}}/cbf4e4e2-614e-4b0d-a7ca-20a1a093266e.html";
                        }
                    }
                    const settings = results[2];
                    const res = results[3];

                    //set default data
                    entity.Ticket = this.props.entity.ProblemNr;
                    if (this.props.entity.Projekt_Key) {
                        entity.Project = this.props.entity.Projekt_Key;
                    }
                    entity.ProjectCode = "0_";
                    entity.Resource = res.Data;
                    entity.ResourceAssignment = true;
                    entity.MaschNr = this.props.entity.Maschine_Key;
                    if (settings.UseComment === true && !Helper.isNullOrEmpty(this.props.entity.Kommentar)) {
                        entity.Remark = this.props.entity.Kommentar.slice(0, 33);
                    }
                    if (typeof settings.InfoSource === "number") {
                        switch (settings.InfoSource) {
                            case 1:
                                if (this.props.context.conversationMode)
                                    entity.Activity = this.props.entity.ProblemHistory.map((value: TicketConversation) => { return value.FullName + " - " + kendo.toString(kendo.parseDate(value.AddDate), "G") + "\n" + value.Text }).join("\n\n");
                                else
                                    entity.Activity = this.props.entity.Problem;
                                break;
                            case 2:
                                if (this.props.context.conversationMode)
                                    entity.Activity = this.props.entity.SolutionHistory.map((value: TicketConversation) => { return value.FullName + " - " + kendo.toString(kendo.parseDate(value.AddDate), "G") + "\n" + value.Text }).join("\n\n");
                                else
                                    entity.Activity = this.props.entity.Loesung;
                                break;
                            case 3:
                                if (this.props.context.conversationMode)
                                    entity.Activity = this.props.entity.AnnotationHistory.map((value: TicketConversation) => { return value.FullName + " - " + kendo.toString(kendo.parseDate(value.AddDate), "G") + "\n" + value.Text }).join("\n\n");
                                else
                                    entity.Activity = this.props.entity.Anmerkung;
                                break;
                            case 4:
                                if (this.props.context.conversationMode) {
                                    const ah = this.props.entity.AnnotationHistory ?? [];
                                    const sh = this.props.entity.SolutionHistory ?? [];
                                    const merged = ah.concat(sh).sort((a, b) => { return kendo.parseDate(a.UTCAddDate).getTime() - kendo.parseDate(b.UTCAddDate).getTime() });
                                    entity.Activity = merged.map((value: TicketConversation) => { return value.FullName + " - " + kendo.toString(kendo.parseDate(value.AddDate), "G") + " - " + this._commentTypeText(value.Type) + "\n" + value.Text }).join("\n\n");
                                }
                                else
                                    entity.Activity = this.props.entity.Anmerkung + "\n" + this.props.entity.Loesung;
                                break;
                            case 5:
                                if (this.props.context.conversationMode) {
                                    const sh = this.props.entity.SolutionHistory ?? [];
                                    const ah = this.props.entity.AnnotationHistory ?? [];
                                    const ph = this.props.entity.ProblemHistory ?? [];
                                    const merged = ah.concat(sh).concat(ph).sort((a, b) => { return kendo.parseDate(a.UTCAddDate).getTime() - kendo.parseDate(b.UTCAddDate).getTime() });
                                    entity.Activity = merged.map((value: TicketConversation) => { return value.FullName + " - " + kendo.toString(kendo.parseDate(value.AddDate), "G") + " - " + this._commentTypeText(value.Type) + "\n" + value.Text }).join("\n\n");
                                }
                                else
                                    entity.Activity = this.props.entity.Problem + "\n" + this.props.entity.Anmerkung + "\n" + this.props.entity.Loesung;
                                break;
                            default:
                                break;
                        }
                    }
                    entity.Address = this.props.entity.Adresse_Key;

                    if (settings.UseTicketDeadline) {
                        entity.StartDate = kendo.parseDate(this.props.entity.Termin1);
                        entity.EndDate = kendo.parseDate(this.props.entity.Termin1);
                    } else {
                        entity.StartDate = new Date();
                        entity.EndDate = new Date();
                    }
                    updateTime(entity.StartDate, settings.WorkStartTime);
                    updateTime(entity.EndDate, settings.WorkEndTime);


                    entity.StartDate = Helper.dates.getISODateString(entity.StartDate)
                    entity.EndDate = Helper.dates.getISODateString(entity.EndDate)



                    const sheet = General.Sheet.Manager.createSheet();
                    sheet.setTitle(this.translations["WebSMS.Ticket.Assignment.NewAssignment"]);
                    sheet.bind(SheetEventType.SavedSuccessfully, (data) => {

                        this.setState({}, () => {
                            let copiedProps = JSON.parse(JSON.stringify(this.props.entity));
                            copiedProps.Projekt_Key = data.entity.Project;
                            Helper.updateEntity(this.props.entity, copiedProps);
                            this.setState({});
                            this.common.sheetWrapper.trigger(SheetEventType.Custom, { event: "Reloading" });
                        });
                    });
                    sheet.show(() => {
                        const props: CreateAssignmentAppProps = {
                            entity: entity,
                            context: { key1: "", key2: "", keyVal1: null, contextType: "assignmentFromTicket" },
                            metadata: metaData,
                            dataSources: {
                                assignmentTypesDS: null
                            },
                            isWindow: true,
                            settings: settings,
                            defaultDeadline: this.props.entity.Termin1,
                            handleMenuSelect: null,
                            enableMenuItem: null,
                            handleCreateValidator: null,
                            handleFieldChange: null,
                            handleDataLoaded: null,
                            onChange: null,
                            fromProject: false
                        };

                        sheet.mountContent(CreateAssignment, props);
                    });
                });
        }
    }

    reopen = async () => {
        await this._handleCloseReopen(false);
    }

    pclose = async () => {
        await this._handleCloseReopen(true);
    }

    openChat = () => {
        openChat(this.props.context);
    }

    editStateAndOpenEmail = async () => {
        await this._internalActionExecute(
            async () => {
                let entity = { proStatusKey: this.props.entity.Vorgangsstatus_Key, problemNr: this.props.entity.ProblemNr, vorgangstyp_Key: this.props.entity.Vorgangstyp_Key };
                let result = await OpenTicketChangeStateDialog(entity, this.props.externalStatusDependsOnTicketType);
                if (result) {
                    await this.onStatusChanged();
                    setTimeout(() => {
                        this.common.evalAction("openEmail()")
                    }, 500)
                }
            }
        );

    }

    private _internalActionExecute = async (callback: any) => {
        if (this._conversationHistoryChangedExistingTextOrType || this._conversationHistoryNewText) {
            let sheet = General.Sheet.Manager.getTopMostSheet();
            let isOK = await DialogHelper.confirm(this.translations["Standard.Ticketsystem.TexteSpeichern"], 700,
                this.translations["Server.No"], this.translations["Server.Yes"])
            if (isOK) {
                sheet.trigger(SheetEventType.Custom, { command: "addTicketText", value: true });
                if (await this.save(false))
                    await callback();
            }
            else {
                sheet.trigger(SheetEventType.Custom, { command: "deleteTicketText", value: true });
                if (this.common.entityChanged) {
                    await this._askUserSaveRequired(callback);
                } else {
                    await callback()
                }
            }
        } else if (this.common.entityChanged) {
            await this._askUserSaveRequired(callback);
        } else if (this.props.entity.IsNew) {
            let saved = await this.save(false);
            if (saved) {
                await callback()
            }
        } else {
            await callback();
        }
    }


    openForward = async () => {
        await this._internalActionExecute(() => this._handleForward());
    }

    openChangeState = async () => {
        await this._internalActionExecute(
            async () => {
                let entity = { proStatusKey: this.props.entity.Vorgangsstatus_Key, problemNr: this.props.entity.ProblemNr, vorgangstyp_Key: this.props.entity.Vorgangstyp_Key };
                let result = await OpenTicketChangeStateDialog(entity, this.props.externalStatusDependsOnTicketType);
                if (result)
                    await this.onStatusChanged();
            }
        );
    }

    onStatusChanged = async () => {
        General.Functions.HistoryState.replaceState(`Procedure/Edit?id=${this.props.entity.ProblemNr}`);
        await this._reloadEntity(false);
    }

    private _askUserSaveRequired = async (callback: any) => {
        let isOk = await DialogHelper.confirm(this.translations["WebSMS.Ticket.SaveRequired"])
        if (!isOk) return;

        let saved = await this.save(false);
        if (saved) {
            await callback()
        }
    }

    private _initApp = () => {

        this._updateButtonFlags();
        this._updateCurrentUrl();

        $(window).on("createAssignment-readyForData", () => {
            $(window).trigger("createAssignment-getData", { entity: this.props.entity });
        })

        this.props.dataSources.prostatuskeyDataSource = [];
        this.props.dataSources.hotkeyDataSource = [];

        this.props.context.materialGrid = this.articleGridOptions;
        this.props.context.historyGrid = this.historyGridOptions;
        this.props.context.ticketLevelGrid = this.ticketLevelGridOptions;
        this.props.context.allocationsTemplate = Helper.useMobileGui() ? this.ticketStructureTemplateMobileApp : this.ticketStructureTemplate;
        this.props.context.editMachineTicketsGridOptions = this.editMachineTicketsGridOptions;
        this.props.context.translations = this.translations;
        this.props.context.reloadEntity = this._reloadEntity;

        this.abhaengigkeitCodes = Config.user.abhaenigkeitCodes;
        if (Helper.hasValue(this.common.unloadHelper))
            this.props.context.isEntitySaved = this.common.unloadHelper.isEntitySaved;

        if (this.props.cascadingCodes === true) {
            const ortCodeMeta = MetaDataHelper.getFieldByProperty(this.props.metadata, "model", "entity.OrtText") && this.abhaengigkeitCodes;
            if (ortCodeMeta) {
                this._errorCodesInitialReadOnlyState.OrtText = this.common.evalAction(ortCodeMeta["readOnly"]) && this.abhaengigkeitCodes;
            }
            const stoerungCodeMeta = MetaDataHelper.getFieldByProperty(this.props.metadata, "model", "entity.StoerungText") && this.abhaengigkeitCodes;
            if (stoerungCodeMeta) {
                this._errorCodesInitialReadOnlyState.StoerungText = this.common.evalAction(stoerungCodeMeta["readOnly"]);
            }
            const ursacheCodeMeta = MetaDataHelper.getFieldByProperty(this.props.metadata, "model", "entity.UrsacheText") && this.abhaengigkeitCodes;
            if (ursacheCodeMeta) {
                this._errorCodesInitialReadOnlyState.UrsacheText = this.common.evalAction(ursacheCodeMeta["readOnly"]);
            }
            const behebungCodeMeta = MetaDataHelper.getFieldByProperty(this.props.metadata, "model", "entity.BehebungText") && this.abhaengigkeitCodes;
            if (behebungCodeMeta) {
                this._errorCodesInitialReadOnlyState.BehebungText = this.common.evalAction(behebungCodeMeta["readOnly"]);
            }
            if (!Helper.hasValue(this.props.entity.OrtCode) && Config.user.abhaenigkeitCodes) {
                this._disableAndResetCodes(2, true);
            } else {
                this._setCodeSearchWindowUrl(CodesType.Location, this.props.entity.OrtCode);
                if (!Helper.hasValue(this.props.entity.StoerungCode) && Config.user.abhaenigkeitCodes) {
                    this._disableAndResetCodes(3, true);
                } else {
                    this._setCodeSearchWindowUrl(CodesType.Fault, this.props.entity.StoerungCode);
                    if (!Helper.hasValue(this.props.entity.UrsacheCode) && Config.user.abhaenigkeitCodes) {
                        this._disableAndResetCodes(4, true);
                    } else {
                        this._setCodeSearchWindowUrl(CodesType.Repair, this.props.entity.UrsacheCode);
                    }
                }
            }
        }

        this._setEvents();

        //if (this.props.context.conversationMode && !Helper.hasValue(this.props.context.conversationHistory)) {
        //    this.props.context.conversationHistory = [];
        //    if (Array.isArray(this.props.entity.ProblemHistory)) {
        //        this.props.context.conversationHistory = this.props.entity.ProblemHistory;
        //    }
        //}

        if (this.props.context.conversationMode) {
            const meta = MetaDataHelper.getFieldByProperty(this.props.metadata, "model", "entity.Problem");
            if (Helper.hasValue(meta)) {
                this._conversationTextRequired = meta.required;
            }

            MetaDataHelper.setRequired(this.props.metadata, "entity.Problem", false);
        }

        if (this.props.entity.RecordRight.CanWrite) {
            this.common.unloadHelper.addBeforeUnloadCallback(() => {
                this.releaseLock();
            });
        }

        //ReadOnly
        this.enableEditButton = this.readOnly && this.props.enableEditButton;
        if (this.readOnly) {
            NotificationHelper.showInfoMessage(this.translations["Vorgang.OpenInReadOnly"].replace("{ticketNr}", this.props.context.keyVal1));
        }
    }



    componentDidMount() {
        if (this.props.entity.RecordRight.CanWrite && Helper.hasValue(this.props.entity.IsId) && !this.props.entity.IsNew) {
            this._lockId = Helper.keepLockAlive("Lock.ashx", this.props.entity.IsId, "PROBLEME", 10000);
        }

        if (!this.props.context.conversationMode) {
            $("#" + this.props.context["elementId"]).on("paste keypress", "textarea", (e) => {
                const $t = $(e.target);
                if ($t[0]["readOnly"] == true)
                    return;
                const model = $t.closest(".field-instance").attr("data-model");
                const parts = model.split(".");
                const propName = parts[parts.length - 1];
                const allowed = ["Problem", "Anmerkung", "Loesung"];

                if (this._firstEdit[propName] !== false && allowed.indexOf(propName) !== -1) {
                    const key = e.key === 'Enter' ? "\n" : e.key;
                    const oldValue = Helper.hasValue(this.props.entity[propName]) ? this.props.entity[propName] : "";
                    const position = $t.prop("selectionStart");
                    const newValue = oldValue.slice(0, position) + key + oldValue.slice(position);

                    const dateString = kendo.toString(new Date(), "G");
                    const computedValue = dateString + " - " + this.props.entity.Settings.UsernameForTimestamp + "\n";
                    //if "paste" event => add the pasted text; otherwise, get the added character
                    const clipboard = (e.originalEvent as any).clipboardData || (window as any).clipboardData;
                    const characterToAdd = e.type === "paste" ? clipboard.getData("text")
                        : Helper.getFirstDiffChar(newValue, oldValue);

                    let updatedValue: string;

                    if (Helper.hasValue(this.props.entity[propName]) && this.props.entity[propName].trim() !== "") {
                        let prepend = "";
                        if (oldValue.trim() !== "") {
                            prepend = oldValue;
                            if (this.props.entity.Settings.ProblemTextVorgangAmAnfangHinzufuegen) {
                                updatedValue = computedValue + characterToAdd + "\n" + prepend;
                            } else {
                                updatedValue = prepend + "\n" + computedValue + characterToAdd;
                            }
                        } else updatedValue = computedValue + characterToAdd;

                    } else {
                        updatedValue = computedValue + characterToAdd;
                    }

                    this.handleFieldChange({ model: model }, updatedValue);
                    if (this.props.entity.Settings.ProblemTextVorgangAmAnfangHinzufuegen) {
                        const input = $(".field-instance[data-model='entity." + propName + "'] textarea")[0];
                        (input as HTMLInputElement).setSelectionRange(computedValue.length + characterToAdd.length, computedValue.length + characterToAdd.length);
                    }

                    e.preventDefault();
                    this._firstEdit[propName] = false;
                }
            });
        }

        this.slaData.notification = this.translations["WebSMS.SLA.Messages.SLAExists"];
    }

    private onTreeDataChanged = (treeData: TreeNodeVm[]) => {
        this.common.setEntityDirtyState(true);
        if (treeData) {
            //
        }
    }

    createSkills = () => {
        let entity: any = this.props.entity;
        return <Skills entity={entity} runningContext="ticket" onTreeDataChanged={this.onTreeDataChanged}
            title={Helper.getTranslation["WebSMS.Skills.Skills"]} />;
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(this.props), { apphelper: this.common, handleFieldChange: this.handleFieldChange, handleIsSearchFieldFullObjectModel: this.handleIsSearchFieldFullObjectModel });
        const titleProps: PageTitleProps = {
            title: this.props.title,
            value: this.props.entity.ProblemNr,
            locked: Helper.hasValue(this.props.entity.LockMessage) && this.props.entity.LockMessage.trim() !== "",
            lockInfo: this.props.entity.LockMessage
        };

        this._addConversationsToContext()

        return (<>
            <CommonApp {...props} titleProps={titleProps} />
        </>);
    }
}

enum CodesType {
    Location, Fault, Cause, Repair
}

interface SlaData {
    slaExists: boolean;
    notification?: string;
}
export interface TicketAppProps extends AppBaseProps {
    entity: EntityTicket;
    context: TicketAppPropsContext;
    externalStatusDependsOnTicketType: boolean;
    externalStatusChangesHotliner: boolean;
    cascadingCodes: boolean;
    readOnly?: boolean;
    enableEditButton?: boolean;
    translations?: [];
}


export interface TicketAppPropsContext extends Context {
    materialGrid?: {};
    historyGrid?: {};
    isEntitySaved(): boolean;
    reloadEntity(): any;
    allocationsTemplate?: string;
    translations: any;
    conversationMode: boolean;
    problemConversation?: Array<TicketConversation>;
    annotationConversation?: Array<TicketConversation>;
    solutionConversation?: Array<TicketConversation>;
    conversation?: Array<TicketConversation>;
    events?: Array<EventEntry>;
    ticketLevelGrid?: {};
    editMachineTicketsGridOptions?: {};
    isTIDActive?: boolean;
    isCopyMaterialToMashActive?: boolean;
    textToHighlight?: string[];
}

export interface EntityTicket extends Entity {
    ProblemNr: number;
    Stufe: number;
    Problem: string;
    Anmerkung: string;
    Loesung: string;
    OrtCode: string;
    OrtText: string;
    StoerungCode: string;
    StoerungText: string;
    UrsacheCode: string;
    UrsacheText: string;
    BehebungCode: string;
    BehebungText: string;
    Projekt_Key: string;
    Adresse_Key: string;
    Maschine_Key: string;
    Termin1: string;
    Kommentar: string;
    Vorgangsstatus_Key: number;
    Vorgangstyp_Key: string;
    StartZeit?: Date;
    StartZeitUtc?: Date;
    Settings: {
        UsernameForTimestamp: string;
        ProblemTextVorgangAmAnfangHinzufuegen: string;
    };
    IsId?: number;
    LockMessage: string;
    RecordRight: {
        CanRead: boolean;
        CanWrite: boolean;
        CanClose: boolean;
        CanForward: boolean;
        CanReopen: boolean;
        CanDelete: boolean;
        Grunddatenrecht: number;
    };
    ProblemHistory: Array<TicketConversation>;
    AnnotationHistory: Array<TicketConversation>;
    SolutionHistory: Array<TicketConversation>;
    Conversation: Array<TicketConversation>;
    Events: Array<EventEntry>;
    SlaExists: boolean;
}
